<template>
    <VuePerfectScrollbar
        class="details-account-container"
        v-loading="isLoading"
    >
        <v-avatar
            size="9rem"
            class="position-relative no-select"
            style="border: 5px solid #eaeaea; margin-left: 3rem"
        >
            <img
                :src="`${user.profilePhoto}`"
                onerror="this.src='/image/avatar-default.svg';"
            />
        </v-avatar>
        <div>
            <div class="detail-item mt-0">
                <div class="detail-title">Email</div>
                <div class="detail-content-bold">
                    {{ user.email }}
                </div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Username</div>
                <div class="detail-content-bold">
                    {{ user.username }}
                </div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Full name</div>
                <div class="detail-content">{{ user.fullName }}</div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Phone</div>
                <div class="detail-content">{{ user.phone }}</div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Gender</div>
                <div class="detail-content">{{ user.gender | gender }}</div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Birthday</div>
                <div class="detail-content">
                    {{ user.birthday | simplyDate }}
                </div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Total recharge</div>
                <div class="detail-content-bold" style="color: forestgreen">
                    $ {{ user.recharged }}
                </div>
            </div>
            <div class="detail-item">
                <div class="detail-title">iRender point</div>
                <div
                    class="d-flex flex-row align-items-center"
                    :style="`color: ${
                        user.balance < 0 ? '#f44336' : '#42a5f5'
                    }`"
                >
                    <div>{{ user.balance.toLocaleString() }}</div>
                    <div class="d-flex flex-row align-items-center ml-1">
                        <img
                            :src="`${
                                user.balance < 0
                                    ? '/static/image/logo-irender-coin-red.svg'
                                    : '/logo/logo-irender-coin.svg'
                            }`"
                            width="11"
                            height="11"
                        />
                    </div>
                </div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Bonus point</div>
                <div
                    class="d-flex flex-row align-items-center"
                    style="color: black"
                >
                    <div>
                        {{ user.extraBalanceRental.toLocaleString() }}
                    </div>
                    <div class="d-flex flex-row align-items-center ml-1">
                        <i class="el-icon-coin"></i>
                    </div>
                </div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Total machine</div>
                <div class="detail-content">
                    <span style="font-weight: 700">
                        {{ user.totalImage }} / {{ user.imageThreshold }}
                    </span>
                    <span class="ml-2">machine</span>
                </div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Network drive Z</div>
                <div class="detail-content">
                    <span style="font-weight: 700">
                        {{ user.totalStorage | formatSize }} /
                        {{ user.storageThreshold | formatSize }}
                    </span>
                </div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Region</div>
                <div>{{ user.region }}</div>
            </div>
            <div class="detail-item">
                <div class="detail-title">Registered at</div>
                <div>{{ user.registerAt | pretyDateUtcToLocal }}</div>
            </div>
        </div>
    </VuePerfectScrollbar>
</template>

<script>
// CSS

// Lib
import { mapState } from "vuex";

// Api

// Constant

// Extend
import base from "@/scripts/base";

// Component

// Function

export default {
    extends: base,

    data() {
        return {};
    },

    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },

    created() {},

    methods: {},
};
</script>